import { ProductComplement } from '../../config/types/contentTypes'
import { DispatchAction } from '../../config/types/contextTypes'

export const APP_PRODUCT_COMPLEMENT_TYPE = 'productComplement'

const Reducer = (state: ProductComplement, action: DispatchAction): ProductComplement => {
  switch (action.type) {
    case APP_PRODUCT_COMPLEMENT_TYPE:
      return { ...action.data }

    default:
      return state
  }
}

export default Reducer
